import cn from 'classnames';
import styled from '@emotion/styled';
import { Props } from './types';
import { color } from '@/utils/index';
import { useRecoilValue } from 'recoil';
import { bottomBarOpenState, tourConfigsState } from 'store';
import { TourType } from '@/_models/Tour';
import { TTheme } from '@/_models/Common';
import { useTheme } from 'styled-components';
import { MainWrap } from './styles';

const StyledImg = styled.img`
  margin-left: -4px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
`;

export const GameLockPathModal = ({ pathSettings, handleNextStep, handlePreviousStep, translationGo, description, isEnablePreviousStep, gameId, pathLockId, isRtl }: Props) => {
  const { colorBackground, opacityBackground, colorButton, opacityButton, colorButtonText, opacityButtonText, colorText, opacityText } = pathSettings;
  const isBbOpen = useRecoilValue(bottomBarOpenState);
  const { tourType } = useRecoilValue(tourConfigsState);
  const { device }: TTheme = useTheme();
  const { mobile, landscape } = device || {};
  const hideConfigsBlock = document.querySelector('.ec-bb-main .hideConfigs');
  let bbOpenBottom = tourType === TourType.ECommerce ? '262px' : '235px';
  let bbClosedBottom = (hideConfigsBlock && !landscape) || (tourType !== TourType.ECommerce && tourType !== TourType.Game) ? '76px' : '55px';
  if (mobile && landscape && tourType === TourType.ECommerce) {
    bbOpenBottom = '187px';
  }
  if (mobile && landscape && tourType !== TourType.ECommerce && tourType !== TourType.Game && !isBbOpen) {
    bbOpenBottom = '52px';
  }
  if (tourType === TourType.Game) {
    bbOpenBottom = '155px';
    if (mobile) {
      bbClosedBottom = '0px';
    } else {
      bbClosedBottom = '55px';
    }
  }

  const BackBtn = () =>
    isEnablePreviousStep && (
      <a
        className="prev-btn"
        onClick={handlePreviousStep}
        style={{
          background: colorButtonText || 'none',
          opacity: opacityButtonText,
          border: `1px solid ${colorButton}`,
        }}
      >
        <span className="btn-text">
          <i
            className="fas fa-arrow-left"
            style={{
              color: colorButton,
              opacity: opacityButton,
            }}
          />
        </span>
      </a>
    );
  return (
    <MainWrap
      className={cn(
        'path-lock-panel-wrap',
        mobile && 'mobile',
        landscape && 'landscape',
        isBbOpen ? 'bbOpen' : 'bbClosed',
        tourType !== TourType.ECommerce && tourType !== TourType.Game && 'regular',
        tourType === TourType.Game && 'game',
        tourType === TourType.ECommerce && 'eCommerce',
        hideConfigsBlock && 'hideConfigsBlock',
      )}
      style={{
        //for regular tour mobile landscape bottom will be 52
        bottom: isBbOpen ? bbOpenBottom : bbClosedBottom,
      }}
    >
      <div
        className={cn('path-lock-panel', mobile && 'mobile')}
        style={{
          backgroundColor: color.hexToRgbA(colorBackground, opacityBackground),
          direction: isRtl ? 'rtl' : 'initial',
        }}
      >
        {pathSettings?.icon && (!mobile || landscape) && (
          <StyledImg src={`${process.env.REACT_APP_AWS}/games/${gameId}/locks/${pathLockId}/${pathSettings?.icon}`} alt="path_image" />
        )}
        {mobile && !landscape && <BackBtn />}
        <div className="path-lock-description" dangerouslySetInnerHTML={{ __html: description }} style={{ color: colorText, opacity: opacityText }} />
        {(!mobile || landscape) && <BackBtn />}
        <button type="button" className="next-btn" onClick={handleNextStep} style={{ background: colorButton || 'none', opacity: opacityButton }}>
          {(!mobile || landscape) && (
            <span
              className="btn-text"
              style={{
                color: colorButtonText,
                opacity: opacityButtonText,
              }}
            >
              {translationGo}
            </span>
          )}
          <i className="fa-solid fa-arrow-right" />
        </button>
      </div>
      <div className="pl-subtitles-space" />
    </MainWrap>
  );
};
